// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"0f379ead","365":"410d1f64"}[chunkId] + ".chunk.css";
};